import { Input } from 'antd';
import SearchIcon from 'assets/Icons/search';
import styled from 'styled-components';

type IInputSearchSuffixIconProps = {
  value?: string;
  onChange?: (value: string) => void;
  placeholder?: string;
};

const InputSearchSuffixIcon = ({ value, onChange, placeholder }: IInputSearchSuffixIconProps) => {
  return (
    <WrapperInputSearch>
      <Input
        value={value}
        onChange={(e) => onChange?.(e.target.value)}
        suffix={<SearchIcon fill={'#fff'} />}
        placeholder={placeholder || 'Search by Staff’s Name'}
        className='search-input'
      />
    </WrapperInputSearch>
  );
};

export default InputSearchSuffixIcon;

const WrapperInputSearch = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  .search-input.ant-input-affix-wrapper {
    border-radius: 100px;
    padding: 0px;
    .ant-input-suffix {
      display: flex;
      width: 56px;
      height: 56px;
      justify-content: center;
      align-items: center;
      gap: 10px;
      border-radius: 0px 100px 100px 0px;
      background: #2d6772;
    }
    input {
      border-radius: 100px;
      padding: 24px;
      height: 56px;
      font-family: Poppins;
      font-size: 22px;
      font-style: normal;
      font-weight: 600;
      line-height: 30px; /* 166.667% */
      text-transform: capitalize;
      align-self: center;
    }
    border: 3px solid #2d6772;
    background: #fff;
  }
`;
